import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { GalleryDto } from '@nusign/picflow-backend-types';
import { take } from 'rxjs';
import { SwitchComponent } from '../../../components/switch/switch.component';
import { GalleryService } from '../../../services/gallery.service';
import { SectionService } from '../../../services/section.service';
import { calcLegacyTheme } from '../../lib/calc-legacy-theme';
import { AccessItemCtaComponent } from '../access-item-cta/access-item-cta.component';
import { AccessItemHeaderComponent } from '../access-item-header/access-item-header.component';
import { AccessItemIconComponent } from '../access-item-icon/access-item-icon.component';
import { AccessItemComponent } from '../access-item/access-item.component';
import { GallerySettingsIconComponent } from '../gallery-settings-icon/gallery-settings-icon.component';

@Component({
  selector: 'app-theme-rounded-corners-item',
  imports: [
    AccessItemComponent,
    AccessItemIconComponent,
    AccessItemHeaderComponent,
    AccessItemCtaComponent,
    GallerySettingsIconComponent,
    SwitchComponent,
    FormsModule,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './theme-rounded-corners-item.component.html',
  styleUrl: './theme-rounded-corners-item.component.scss',
})
export class ThemeRoundedCornersItemComponent {
  private galleryService = inject(GalleryService);
  private sectionService = inject(SectionService);
  gallery = input.required<GalleryDto>();
  theme = computed(() => {
    if (!this.gallery()) return;
    return this.gallery().theme || calcLegacyTheme(this.gallery());
  });

  updateRoundedCorners(roundedCorners: boolean) {
    this.galleryService.updateGallery(this.gallery().id, {
      theme: {
        ...this.theme(),
        section: {
          ...this.theme().section,
          rounded_corners: roundedCorners,
        },
      },
    });

    this.sectionService
      .getSections(this.gallery().id)
      .pipe(take(1))
      .subscribe(sections => {
        sections.forEach(section => {
          if (section.rounded_corners === null) return;
          this.sectionService
            .updateSection(section, {
              rounded_corners: null,
            })
            .subscribe();
        });
      });
  }
}
